<template>
    <v-container fluid fill-height>
        <v-layout text-center wrap align-center>
            <v-flex xs12 sm12>
                <h1 class="display-1 my-5">
                    <span class="font-weight-bold">Criadores</span>
                    | Nova Música Gospel
                </h1>

                <v-layout class="my-5" grid-list-xl wrap justify-center>
                    <v-flex xs12 sm8 md8 xl5 mt-5 mb-5>
                        <span class="font-weight-bold">Esqueceu a senha?</span>
                        <br />
                        <p ><span>Informe seu e-mail e enviaremos instruções para você criar uma nova senha</span></p>
                        <v-alert
                            style="text-align:left;"
                            prominent
                            v-show="show_message"
                            :type="message_item.type"
                        >{{message_item.message}}</v-alert>
                    </v-flex>
                    <v-flex xs12 sm8 mt-5>
                        <v-progress-circular
                            v-show="loading"
                            :size="50"
                            indeterminate
                            color="primary"
                        ></v-progress-circular>
                    </v-flex>
                    <v-flex xs12 sm7 xl5 mt-5 v-if="!email_sent">
                        <v-form @keyup.native.enter="login()">
                            <v-text-field
                                label="Email"
                                name="email"
                                prepend-icon="person"
                                type="text"
                                messages="Digite o endereço de e-mail vinculado a sua conta."
                                v-model="credential.email"
                                autocomplete="username"
                                v-validate="'required|email'"
                                data-vv-name="email"
                                :error-messages="errors.collect('email')"
                                :disabled="loading"
                            ></v-text-field>
                        </v-form>
                    </v-flex>
                    <v-flex xs12 sm8 mt-5 v-if="!email_sent">
                        <v-btn outlined large text   :disabled="loading" @click="request_new_password()" color="primary">enviar</v-btn>
                    </v-flex>
                    <v-flex xs12 sm8 mt-5 v-if="email_sent">
                        <v-btn
                            outlined
                            large
                          
                            text
                            :to="{path:'login'}"
                            color="primary"
                        >ENTRAR</v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Vue from "vue";
import VeeValidate from "vee-validate";
import LoginService from "../../app/Rest/auth";

var loginService = null;

Vue.use(VeeValidate);

export default {
    $_veeValidate: {
        validator: "new"
    },
    data: () => ({
        email_sent: false,
        show_message: false,
        loading: false ,

        credential: {
            email: ""
        },
        message_item: { type: "success", message: null },
        dictionary: {
            attributes: {
                email: "E-mail Address"
                // custom attributes
            },
            custom: {
                email: {
                    required: "E-mail é um campo obrigatório.",
                    email: "Esse não parece um e-mail válido."
                }
            }
        }
    }),
    created: function() {
        loginService = LoginService.build();

        this.show_message = false;
    },
    updated: function() {
        this.email = "";
    },
    mounted() {
        this.$validator.localize("pt_br", this.dictionary);
        //this.cover = this.product.cover;
    },
    methods: {
        request_new_password() {
            this.$validator.validateAll().then(is_valid => {
                if (!is_valid) {
                    console.log("nao é valido")
                    return;
                }

                this.loading = true;
                this.show_message = false;                
                loginService
                    .request_new_password(this.credential.email)
                    .then(e => {
                        this.message_item.type="success"
                        if(e.status == "error"){
                            this.message_item.type="error"
                        }else{
                            this.email_sent = true;
                        }
                        this.message_item.message = e.msg;
                    }).catch( ()=>{
                         this.message_item.type="error"
                         this.message_item.message = "Tivemos um problema durante o processamento da sua requisição. Por favor entre em contato no contato@novamusicagospel.com.br e nos relate esse problema.";
                    })
                    .finally(() => {
                        this.show_message = true;
                        this.loading = false;
                    });
            });
        }
    }
};
</script>
